export * from './chip-list';
export * from './chip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/chips/index.js
// module id = 646
// module chunks = 3